<h2>Payers</h2>
<hr />

<div>
  <app-grid-wrapper #grid persistenceKey="payersList">
    <button class="btn btn-primary" (click)="addEntity()"><i class="fa fa-plus"></i> Add</button>
  </app-grid-wrapper>
</div>
